// VanJS Feather - Shield
import van from "vanjs-core";
import { FeatherIcon, svgNamespace } from "../FeatherIcon.ts";
import { type SVGProps } from "../types.ts";

export const Shield = (props: Partial<SVGProps> = {}) => {
  const { path } = van.tags(svgNamespace);

  return FeatherIcon(
    props,
    path({ "d": "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" }),
  );
};
